// extracted by mini-css-extract-plugin
export default {"informedWrapper":"informed_informedWrapper__JX7qQ","titleBlock":"informed_titleBlock__rppRd","contentBlock":"informed_contentBlock__8UWqV"};